import { notify } from '@yembo/yemblocks-core';
import { saveAs } from 'file-saver';
import { s3MediaRequest } from 'src/api/s3/s3MediaRequest';

export const downloadFile = async (fileUrl: string, insuredName: string): Promise<void> => {
  const extension = fileUrl.split('?').shift()?.split('/').pop()?.split('.').pop();
  const fileName = `${insuredName}.${extension ?? ''}`.replace(/\s+/g, '_');
  try {
    const response = await s3MediaRequest(fileUrl);

    saveAs(response, fileName);
    notify.success(`${fileName} was successfully downloaded!`);
  } catch (_error) {
    notify.error(`Failed to download ${fileName}.`);
  }
};
